exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FaqAccordian-pt-5-dRgI- {\n    padding-top: 5rem;\n}\n\n.FaqAccordian-contentColor-WAO0W {\n    color: var(--second-font-color);\n}", ""]);

// exports
exports.locals = {
	"pt-5": "FaqAccordian-pt-5-dRgI-",
	"contentColor": "FaqAccordian-contentColor-WAO0W"
};